import { IMAGE, SWITCH, TEXT } from "../../components/Common/Const";

export const EntitySocketFields = [
    {
        type: TEXT,
        name: "serverName",
        label: "Server Name",
        parentclassName: "",
        isRequired: true,
        regex: /^.{0,100}$/,
        regexErrorMessage: "Max allowed Characters 100",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter server name.",
    },
    {
        type: TEXT,
        name: "url",
        label: "URL",
        parentclassName: "",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter url.",
    },
    {
        type: TEXT,
        name: "reconnectDelay",
        label: "Reconnect Delay",
        parentclassName: "",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter reconnect delay.",
    },
    {
        type: TEXT,
        name: "reconnectAttempts",
        label: "Reconnect Attempts",
        parentclassName: "",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter reconnect attempts.",
    },
    {
        type: TEXT,
        name: "reconnectMaxDelay",
        label: "Reconnect Max Delay",
        parentclassName: "",
        isRequired: true,
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        requiredErrorMessage: "Please enter reconnect max delay.",
    },
    {
        name: "isActive",
        label: "Is Active",
        defaultValue: true,
        parentclassName: "",
        type: SWITCH,
    },
    {
        type: IMAGE,
        name: "defaultTeamImage",
        label: "Team Image",
        // customStyle: {
        //     maxWidth: "200px",
        //     paddingLeft:"0px"
        //   },
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        isValidateImage: true,        
        validateWidth:400,
        validateHeight:400  
    },
    {
        type: IMAGE,
        name: "defaultJerseyImage",
        label: "Jersy Image",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        isValidateImage: true,        
        validateWidth:664,
        validateHeight:254  
    },
    {
        type: IMAGE,
        name: "defaultPlayerImage",
        label: "Player Image",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        isValidateImage: true,        
        validateWidth:310,
        validateHeight:300  
    },
    {
        type: IMAGE,
        name: "defaultPlayerJerseyImage",
        label: "Player Jersey Image",
        labelColspan: { xs: 12, md: 2, lg: 2 },
        fieldColspan: { xs: 12, md: 4, lg: 4 },
        // isValidateImage: true,        
        // validateWidth:279,
        // validateHeight:376  
    },
    {
        name: "isAutoScoreUpdate",
        label: "Is Auto Score Update",
        defaultValue: false,
        parentclassName: "",
        type: SWITCH,
    },
    {
        name: "isAutoUpdateCommentary",
        label: "Is Auto Update Commentary",
        defaultValue: false,
        parentclassName: "",
        type: SWITCH,
    },
]